export class BaseInfo {
  public _id: string;
}
